export const CREATE_ORDER_START = 'CREATE_ORDER_START';
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
export const CREATE_ORDER_FAIL = 'CREATE_ORDER_FAIL';
export const CREATE_ORDER_RESET = 'CREATE_ORDER_RESET';

export const GET_ORDER_START = 'GET_ORDER_START';
export const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS';
export const GET_ORDER_FAIL = 'GET_ORDER_FAIL';

export const ORDER_PAID_START = 'ORDER_PAID_START';
export const ORDER_PAID_SUCCESS = 'ORDER_PAID_SUCCESS';
export const ORDER_PAID_FAIL = 'ORDER_PAID_FAIL';
export const ORDER_PAID_RESET = 'ORDER_PAID_RESET';

export const ORDER_APPROVED_START = 'ORDER_APPROVED_START';
export const ORDER_APPROVED_SUCCESS = 'ORDER_APPROVED_SUCCESS';
export const ORDER_APPROVED_FAIL = 'ORDER_APPROVED_FAIL';
export const ORDER_APPROVED_RESET = 'ORDER_APPROVED_RESET';

export const ORDER_CANCELLED_START = 'ORDER_CANCELLED_START';
export const ORDER_CANCELLED_SUCCESS = 'ORDER_CANCELLED_SUCCESS';
export const ORDER_CANCELLED_FAIL = 'ORDER_CANCELLED_FAIL';
export const ORDER_CANCELLED_RESET = 'ORDER_CANCELLED_RESET';

export const ORDER_DILIVERD_START = 'ORDER_DILIVERD_START';
export const ORDER_DILIVERD_SUCCESS = 'ORDER_DILIVERD_SUCCESS';
export const ORDER_DILIVERD_FAIL = 'ORDER_DILIVERD_FAIL';
export const ORDER_DELIVER_RESET = 'ORDER_DELIVER_RESET';

export const AUTH_ORDER_FETCH_START = 'AUTH_ORDER_FETCH_START';
export const AUTH_ORDER_FETCH_SUCCESS = 'AUTH_ORDER_FETCH_SUCCESS';
export const AUTH_ORDER_FETCH_FAIL = 'AUTH_ORDER_FETCH_FAIL';

export const ORDERLIST_FETCH_START = 'ORDERLIST_FETCH_START';
export const ORDERLIST_FETCH_SUCCESS = 'ORDERLIST_FETCH_SUCCESS';
export const ORDERLIST_FETCH_FAIL = 'ORDERLIST_FETCH_FAIL';

export const DELETE_ORDER_START = 'DELETE_ORDER_START';
export const DELETE_ORDER_SUCCESS = 'DELETE_ORDER_SUCCESS';
export const DELETE_ORDER_FAIL = 'DELETE_ORDER_FAIL';
export const DELETE_ORDER_RESET = 'DELETE_ORDER_RESET';
